// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"ee9c6285","186":"2574a677","206":"2574a677","588":"2574a677"}[chunkId] + ".chunk.css";
};